<div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="0px">
  <img src="../assets/pom-logo-final.png" width="50%" alt="">
</div>
